

function Datenschutz() {
  return <div className="main-wrapper">
    
      
    <h2>Datenschutzerklärung</h2>

    <p>
      Ich nehme den Schutz Ihrer persönlichen Daten sehr ernst und behandele Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
    </p>

    <p>
      Die Nutzung meiner Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Falls auf meinen Seiten personenbezogene Daten (z.B. Name, Anschrift oder E-Mail) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
    </p>

    <p>
      Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
    </p>

    <p>
      Der Nutzung von, z.B. im Rahmen der Impressumspflicht veröffentlichten, Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Ich behalte mir ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen vor.
    </p>

  </div>
}
export default Datenschutz;